import API from "../../../app/api";

export const getCustomerOrder = async (orderToken) => {
  if (!orderToken) {
    throw new Error("Order token is required");
  }

  const response = await API.get(
    `/orders/view/${encodeURIComponent(orderToken)}`
  );

  return response.data;
};